import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { cloneDeep, isArray, isNil } from 'lodash-es';

export type SharedSelectPictoCardEmits = {
	(e: 'input' | 'update:modelValue', value: Picto[] | Picto): void
	(e: 'add' | 'remove', value: any): void
};

export type SharedSelectPictoCardProps = {
	required?: boolean
	options?: Picto[] | null
	modelValue?: Picto[] | Picto | null
	size?: number
};

export default class SharedSelectPictoCardSetup extends BaseSetup {

	static readonly defaultProps = {
		options: null,
		modelValue: null,
	};

	@Reactive private readonly state = {
		selectedItems: [] as Picto[],
		displayValidationState: undefined as Undef<boolean>,
		toggleSelectAll: false,
	};

	private get isMultiple () { return isArray(this.props.modelValue) }

	get displayValidationState () { return this.state.displayValidationState }
	set displayValidationState (val) { this.state.displayValidationState = val }

	private get vModel () { return this.props.modelValue }
	private set vModel (val: Picto[] | Picto | null | undefined) {
		if (val) {
			this.emits('update:modelValue', val);
		}
	}

	constructor (
		private props: SharedSelectPictoCardProps,
		private emits: SharedSelectPictoCardEmits,
	) {
		super();
	}

	onMounted () {
		if (isArray(this.props.modelValue)) {
			this.state.selectedItems = this.props.modelValue ?? [];
		}
		else {
			this.state.selectedItems = this.props.modelValue?.icon ? [this.props.modelValue] : [];
		}
	}

	isValid () {
		return this.state.selectedItems.length > 0;
	}

	isSelected (e: Picto) {
		// return !!this.state.selectedItems?.find(x => x.id === e.id);
		return isArray(this.vModel)
			? !!this.vModel.find(x => x.id === e.id)
			: this.vModel === e;

	}

	private itemMatchOption (option: Picto, item: Picto) {
		return !isNil(item)
			? item.id === option.id
			: false;
	}

	private optionIsSelected (option: Picto) {
		let isSelect = false;

		if (this.isMultiple) {
			if (isArray(this.vModel)) {
				const index = this.vModel.findIndex(item => this.itemMatchOption(option, item));
				isSelect = index > -1;
			}
		}
		else {
			isSelect = this.itemMatchOption(option, this.vModel as Picto);
		}

		return isSelect;
	}

	private emitValue (valueToEmit: any) {
		this.vModel = valueToEmit;
	}

	selectItem (value: Picto) {

		if (this.isMultiple) {
			if (this.optionIsSelected(value)) {
				this.emits('remove', value);
				let valueToEmit = cloneDeep(this.vModel as Picto[]);
				let index;

				if (!valueToEmit?.length) {
					valueToEmit = [];
				}
				else {
					index = valueToEmit.findIndex((x: Picto) => x.id === value.id);

					if (index > -1) {
						valueToEmit.splice(index, 1);
					}
				}
				this.emitValue(valueToEmit);
			}
			else {
				this.emits('add', value);
				let valueToEmit = cloneDeep(this.vModel);

				if (!isArray(valueToEmit)) valueToEmit = [];
				valueToEmit.push(value);
				this.emitValue(valueToEmit);
			}
		}
		else {
			this.emits('input', value);
			this.emitValue(value);
		}
	}

}
